"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M23.88,21,15.25,6.79,12.58,2.21a.76.76,0,0,0-1.32,0L8.67,6.75,2,18,.11,21.09a.77.77,0,0,0,0,.78.7.7,0,0,0,.67.29H23.24A.76.76,0,0,0,23.88,21ZM10.79,8.07A1.19,1.19,0,0,1,12,6.95,1.19,1.19,0,0,1,13.3,8.07V14.3A1.19,1.19,0,0,1,12,15.42a1.19,1.19,0,0,1-1.25-1.12ZM12,20.45A1.48,1.48,0,1,1,13.53,19,1.48,1.48,0,0,1,12,20.45Z",
    fill: "#f7b032"
  }));
};

exports["default"] = _default;